var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandArrowSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 24,
    viewBox: "0 0 11 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.44042 9.2661L5.90485 12.8017L2.36929 9.2661C2.28493 9.18173 2.18477 9.11481 2.07455 9.06916C1.96432 9.0235 1.84618 9 1.72687 9C1.60756 9 1.48943 9.0235 1.3792 9.06916C1.26897 9.11481 1.16882 9.18173 1.08446 9.2661C1.00009 9.35046 0.933173 9.45061 0.887516 9.56084C0.841859 9.67107 0.818359 9.78921 0.818359 9.90851C0.818359 10.0278 0.841859 10.146 0.887516 10.2562C0.933173 10.3664 1.00009 10.4666 1.08446 10.5509L5.26699 14.7335C5.62237 15.0888 6.19645 15.0888 6.55183 14.7335L10.7344 10.5509C10.8188 10.4666 10.8859 10.3665 10.9316 10.2563C10.9773 10.146 11.0008 10.0279 11.0008 9.90851C11.0008 9.78917 10.9773 9.671 10.9316 9.56077C10.8859 9.45053 10.8188 9.3504 10.7344 9.2661C10.379 8.91983 9.7958 8.91072 9.44042 9.2661Z",
    fill: "#FBFBFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandArrowSmall);
export default __webpack_public_path__ + "static/media/expand_arrow_small.27a4817a41e61b7be58aaf214ed6342d.svg";
export { ForwardRef as ReactComponent };